(() => {
  const parseData = (node) => { try { let value = JSON.parse(node?.textContent || '{}'); return typeof value === 'string' ? JSON.parse(value) : value; } catch (_) { return {}; } };
  const safeUrl = (value) => { try { const url = new URL(value, location.origin); if (!['http:', 'https:'].includes(url.protocol)) return ''; if (url.protocol === 'http:') url.protocol = 'https:'; return url.href; } catch (_) { return ''; } };
  const element = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text != null) node.textContent = text; return node; };
  function initReviews(root) {
    if (root.dataset.pxReady) return;
    root.dataset.pxReady = 'true';
    const data = parseData(root.querySelector('[data-px-reviews-data]'));
    const track = root.querySelector('[data-px-reviews-track]');
    const dialog = root.querySelector('[data-px-review-dialog]');
    const chosen = [];
    for (const product of data.products || []) {
      let feed = product.feed;
      if (typeof feed === 'string') { try { feed = JSON.parse(feed); } catch (_) { feed = {}; } }
      const review = (feed?.reviews || []).find(review => String(review.product?.id) === String(product.id) && review.author && review.review && (review.media || []).some(media => media.t === 'photo' && safeUrl(media.src)));
      if (review) chosen.push({ product, review });
      if (chosen.length >= (Number(data.limit) || 12)) break;
    }
    if (!chosen.length) { root.hidden = true; return; }
    for (const { product, review } of chosen) {
      const photo = review.media.find(media => media.t === 'photo' && safeUrl(media.src));
      const score = Math.max(0, Math.min(5, Math.round(Number(review.rating) || 0)));
      const card = element('article', 'px-review');
      const author = element('div', 'px-review__author');
      author.append(element('span', '', review.author));
      const stars = element('div', 'px-review__stars', '★'.repeat(score) + '☆'.repeat(5 - score));
      stars.setAttribute('aria-label', `${score} out of 5 stars`);
      const text = element('p', 'px-review__text', review.review);
      const more = element('button', 'px-read-more', 'Read full review'); more.type = 'button';
      more.addEventListener('click', () => {
        dialog.querySelector('[data-px-review-author]').textContent = review.author;
        dialog.querySelector('[data-px-review-text]').textContent = review.review;
        const link = dialog.querySelector('[data-px-review-product]'); link.textContent = product.title; link.href = safeUrl(product.url);
        if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      });
      const image = element('img', 'px-review__photo'); image.src = safeUrl(photo.src); image.alt = photo.alt || `Customer photo for ${product.title}`; image.loading = 'lazy';
      const productLink = element('a', 'px-review__product'); productLink.href = safeUrl(product.url);
      if (safeUrl(product.image)) { const thumbnail = element('img'); thumbnail.src = safeUrl(product.image); thumbnail.alt = product.title; thumbnail.loading = 'lazy'; productLink.append(thumbnail); }
      productLink.append(element('span', '', product.title)); const arrow = element('b', '', '↗'); arrow.setAttribute('aria-hidden', 'true'); productLink.append(arrow);
      card.append(author, stars, text, more, image, productLink); track.append(card);
    }
    root.querySelector('[data-px-close-review]')?.addEventListener('click', () => dialog.close());
    root.querySelectorAll('[data-px-reviews-scroll]').forEach(button => button.addEventListener('click', () => track.scrollBy({ left: Number(button.dataset.pxReviewsScroll) * (track.clientWidth + 20), behavior: 'smooth' })));
  }
  function initTabs(root) {
    if (root.dataset.pxReady) return;
    const config = parseData(root.querySelector('[data-px-tabs-config]'));
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    let moved = false;
    for (const key of ['features', 'specifications', 'videos']) {
      const panel = root.querySelector(`[data-px-panel="${key}"]`);
      for (const id of String(config[key] || '').split(',').map(id => id.trim()).filter(Boolean)) {
        const section = document.getElementById(`shopify-section-${config.prefix}__${id}`);
        if (section && !panel.contains(section)) { panel.append(section); moved = true; }
      }
    }
    root.dataset.pxReady = 'true';
    const pauseHidden = () => panels.filter(panel => panel.hidden).forEach(panel => panel.querySelectorAll('video').forEach(video => video.pause()));
    function select(tab) {
      tabs.forEach(button => { button.setAttribute('aria-selected', String(button === tab)); button.tabIndex = button === tab ? 0 : -1; });
      panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      pauseHidden();
      window.dispatchEvent(new Event('resize'));
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); select(tabs[next]); tabs[next].focus();
      });
    });
    select(tabs[0]);
    const observer = new MutationObserver(pauseHidden);
    panels.forEach(panel => observer.observe(panel, { childList: true, subtree: true }));
  }
  function initStickyMedia(root) {
    if (root.dataset.pxStickyReady) return;
    root.dataset.pxStickyReady = 'true';
    const header = document.querySelector('.site-header');
    const update = () => root.style.setProperty('--px-media-sticky-top', `${Math.ceil(header?.getBoundingClientRect().height || 72) + 16}px`);
    update();
    window.addEventListener('resize', update, { passive: true });
    if (header && 'ResizeObserver' in window) new ResizeObserver(update).observe(header);
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-px-reviews]').forEach(initReviews);
    scope.querySelectorAll('[data-px-details]').forEach(initTabs);
    scope.querySelectorAll('[data-product-root]').forEach(initStickyMedia);
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
